export default __webpack_public_path__ + "static/media/no hijab visa.daba5dab.jpg";